<template>
  <div>
        <SearchYourDelivery></SearchYourDelivery>
  </div>
</template>


<script>

  import SearchYourDelivery from "./Search/SearchYourDelivery";
  // import MultiFiltersPlugin from './plugins/MultiFilters'
  export default {
    name: "Search",
    components: {SearchYourDelivery},
    data() {
      return {}
    },
    methods: {},
    mounted() {
    }
  };
</script>

<style scoped>

  .search-box {
    height: 100%;
  }

  .search-fields {
    width: 684.5px;
    padding: 16px;
  }

  /*.map {*/
  /*width: 684.5px;*/
  /*margin: 0px;*/
  /*}*/

  .sortable {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Search.vue